<template>
  <div class="wrap">
    <userHead></userHead>
    <div class="content display_flex EC_width">
      <div class="contentLeftMenu">
        <ul class="newMenu">
          <li :class="{ newMenuActive: activeMenu == index }" v-for="(item, index) in menuList"
            @click="tagMenu(item.pathName, index)" :key="index">
            <span class="newMenuItem">
              <img v-for="(itemimg, indeximg) in item.img" :key="indeximg + '1'" :src="itemimg"
                :class="[indeximg == 0 ? 'normalImg' : 'activeImg']" />
              {{ item.title }}
              <a style="margin-left:15%" v-if="item.dropMenu != null && item.dropMenu.length > 0"><img
                  v-if="activeMenu != index" src="/image/geren/xiangshang.png" /><img v-else-if="activeMenu == index"
                  src="/image/geren/xiangxia.png" /></a>
            </span>
            <template v-if="item.dropMenu.length > 0">
              <ul class="DropMenu" @click.stop>
                <li :class="{ DropMenuActive: activeDropMenu == indexx }" class="DropMenuItem"
                  v-for="(itemx, indexx) in item.dropMenu" @click="tagDropMenu(itemx.pathName, indexx, itemx)"
                  :key="indexx">
                  <span :class="[itemx.dropMenu != null && itemx.dropMenu.length ? 'inlinestart20' : '']"> {{
                    itemx.title
                  }}</span>
                  <a v-if="itemx.dropMenu != null && itemx.dropMenu.length > 0">
                    <img v-if="activeDropMenu != indexx" src="/image/geren/chixiangshang.png"
                      style="vertical-align:top; margin-top: 12px;" />
                    <img v-else-if="activeDropMenu == indexx" src="/image/geren/chixiangxia.png"
                      style="vertical-align:top; margin-top: 12px;" />
                  </a>
                  <template v-if="itemx.dropMenu != null && itemx.dropMenu.length > 0">
                    <ul :class="[activeDropMenuTowdispaly == true ? 'DropMenuActiveTow' : 'DropMenuTow']"
                      class="DropMenu " style="padding-inline-start: 20px;" @click.stop>
                      <li :class="{ DropMenuActive: activeDropMenuTow == indexxx }" class="DropMenuItem"
                        v-for="(itemxx, indexxx) in itemx.dropMenu" :key="indexxx"
                        @click="tagDropMenuTow(itemxx.pathName, indexxx)">
                        <span v-if="itemxx.isdisplay">{{ itemxx.title }}</span>
                        <span v-else-if="!itemxx.isdisplay">{{ itemxx.title }}</span>
                      </li>
                    </ul>
                  </template>
                </li>
              </ul>
            </template>
          </li>
        </ul>
      </div>
      <div class="contentRightMenu">
        <router-view></router-view>
      </div>
    </div>
    <!-- <footer_index></footer_index> -->
  </div>
</template>

<script>
import { title } from 'process';
import userHead from './user_head';
// import footer_index from "../home/footer_index"
export default {
  name: 'index',
  data() {
    return {
      tagIndex: 'userInfor',
      menuList: [
        {
          pathName: 'userInfor',
          title: '个人中心',
          img: ['/image/geren/menuIcon1.png', '/image/geren/menuActive1.png'],
          dropMenu: []
        },
        {
          pathName: '',
          title: '全科知家',
          img: ['/image/geren/menuIcon2.png', '/image/geren/menuActive2.png'],
          dropMenu: [
            { pathName: 'userVip', title: 'VIP 中心' },
            { pathName: 'userMyInvoice', title: '我的发票' },
            {
              pathName: '',
              title: '我的课程',
              dropMenu: [
                { pathName: 'userMyCourse', isdisplay: true, title: '购买课程' },
                { pathName: 'userorgCourse', isdisplay: false, title: '机构课程' },
                { pathName: 'userCmeCourse', isdisplay: false, title: 'CME课程' }
              ]
            },
            { pathName: 'userMyOrder', title: '我的订单' },
            { pathName: 'userMyCollection', title: '我的收藏' },
            { pathName: 'userExchange', title: '兑换入口' },
            { pathName: "userShopping", title: "我的购物车" },
            { pathName: 'userCredits', title: '学分卡购买' },
          ]
        },
        {
          pathName: 'userMyMeeting',
          title: '我的会议',
          img: ['/image/geren/menuIcon3.png', '/image/geren/menuActive3.png'],
          dropMenu: []
        },
        {
          pathName: '',
          title: '我的直播',
          img: ['/image/geren/live.png', '/image/geren/liveactive.png'],
          dropMenu: [
            { pathName: 'userLive', title: '我的直播' },
            { pathName: 'liveclass', title: '直播课程' },
            { pathName: 'livesub', title: '直播订阅' },
            { pathName: 'livecollect', title: '直播收藏' },
            { pathName: 'liveorder', title: '直播订单' }
          ]
        },
        {
          pathName: 'userSubscribe',
          title: '学术订阅',
          img: ['/image/geren/menuIcon4.png', '/image/geren/menuActive4.png'],
          dropMenu: []
        },
        {
          pathName: 'userMymsg',
          title: '我的消息',
          img: ['/image/geren/menuIcon5.png', '/image/geren/menuActive5.png'],
          dropMenu: []
        },
        {
          pathName: '',
          title: '我要入驻',
          img: ['/image/geren/menuIcon6.png', '/image/geren/menuActive6.png'],
          dropMenu: [
            { pathName: 'userExpertsEnter', title: '专家入驻' },
            { pathName: 'userOrgEnter', title: '机构入驻' }
          ]
        },
        {
          pathName: 'userStoreCenter',
          title: '店铺中心',
          img: ['/image/geren/menuIcon7.png', '/image/geren/menuActive7.png'],
          dropMenu: []
        }
      ],
      activeMenu: 0,
      activeDropMenu: 0,
      activeDropMenuTow: -1,
      activeDropMenuTowdispaly: false
    };
  },
  created() {
    switch (this.$route.name) {
      case 'userMyOrder':
        this.activeMenu = 1;
        this.activeDropMenu = 3;
        break;
      case 'userShopping':
        this.activeMenu = 1;
        this.activeDropMenu = 6;
        break;
      case 'userMyCourse':
        this.activeMenu = 1;
        this.activeDropMenu = 2;
        this.activeDropMenuTow = 0;
        this.activeDropMenuTowdispaly = true;
        break;
      case 'userMyCollection':
        this.activeMenu = 1;
        this.activeDropMenu = 4;
        break;
      case 'userVip':
        this.activeMenu = 1;
        this.activeDropMenu = 0;
        break;
      case 'userMyInforShow':
        this.activeMenu = 0;
        this.activeDropMenu = 0;
        break;
      case 'userMyMeeting':
        this.activeMenu = 2;
        this.activeDropMenu = 0;
        break;
      case 'userlive':
        this.activeMenu = 3;
        this.activeDropMenu = 0;
        break;
      case 'userorgCourse':
        this.activeMenu = 1;
        this.activeDropMenu = 2;
        this.activeDropMenuTow = 1;
        this.activeDropMenuTowdispaly = true;
        break;
      case 'userExchange':
        this.activeMenu = 1;
        this.activeDropMenu = 5;
        break;
      case 'userMyInvoice':
        this.activeMenu = 1;
        this.activeDropMenu = 1;
        break;
      case 'userCredits':
        this.activeMenu = 1;
        this.activeDropMenu = 7;
        break;
    }
  },
  components: {
    userHead
    // footer_index,
  },
  methods: {
    tagContent(index) {
      this.tagIndex = index;

      this.$router.push({ name: this.tagIndex });
    },
    tagMenu(pathName, index) {
      this.activeMenu = index;
      this.activeDropMenuTow = -1;
      this.activeDropMenu = -1;
      this.activeDropMenuTowdispaly = false;
      this.$router.push({ name: pathName });
    },
    tagDropMenu(pathName, index, itemx) {
      if (itemx.dropMenu != null) {
        this.activeDropMenuTowdispaly = true;
        this.activeDropMenuTow = -1;
        this.activeDropMenu = '';
      } else {
        this.activeDropMenuTowdispaly = false;
      }
      this.activeDropMenu = index;
      this.$router.push({ name: pathName });
    },
    tagDropMenuTow(pathName, index) {
      this.activeDropMenuTow = index;
      this.$router.push({ name: pathName });
    }
  },
  watch: {
    $route: {
      handler: function (val) {
        switch (val.name) {
          case 'userMyOrder':
            this.activeMenu = 1;
            this.activeDropMenu = 3;
            break;
          case 'userMyCourse':
            this.activeMenu = 1;
            this.activeDropMenu = 2;
            this.activeDropMenuTow = 0;
            this.activeDropMenuTowdispaly = true;
            break;
          case 'userMyCollection':
            this.activeMenu = 1;
            this.activeDropMenu = 4;
            break;
          case 'userVip':
            this.activeMenu = 1;
            this.activeDropMenu = 0;
            break;
          case 'userMyInforShow':
            this.activeMenu = 0;
            this.activeDropMenu = 0;
            break;
          case 'userMyMeeting':
            this.activeMenu = 2;
            this.activeDropMenu = 0;
            break;
          case 'userMyInvoice':
            this.activeMenu = 1;
            this.activeDropMenu = 1;
            break;
          case 'userExchange':
            this.activeMenu = 1;
            this.activeDropMenu = 5;
            break;
          case 'userorgCourse':
            this.activeMenu = 1;
            this.activeDropMenu = 2;
            this.activeDropMenuTow = 1;
            this.activeDropMenuTowdispaly = true;
            break;
          case 'userShopping':
            this.activeMenu = 1;
            this.activeDropMenu = 6;
            break;
          case 'userCredits':
            this.activeMenu = 1;
            this.activeDropMenu = 7;
            break;
        }
      }
    }
  }
};
</script>

<style scoped>
.activeImg {
  display: none;
}

.pubL_menu_active .activeImg {
  display: inline-block;
}

.pubL_menu_active .normalImg {
  display: none;
}

.wrap {
  min-height: 800px;
  display: flex;
  flex-direction: column;
}

/* 左边菜单部分 */
.pubL_menu {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 184px;
}

.pubL_menu li {
  position: relative;
}

.pubL_menu li a {
  display: inline-block;
  height: 46px;
  width: 138px;
  text-align: center;
  line-height: 46px;
}

.pubL_menu li a img {
  float: left;
  margin-left: 30px;
  margin-top: 15px;
}

.arrtig {
  position: absolute;
  width: 0;
  height: 0;
  border: solid 23px;
  border-color: transparent transparent transparent #0b8686;
  right: 0;
  top: 0;
  display: none;
}

.pubL_menu_active a {
  background: #0b8686;
  color: #fff;
  border-radius: 6px 0 0 6px;
}

.pubL_menu_active .arrtig {
  display: block;
}

.content {
  flex: 1;
  padding-top: 40px;
  padding-bottom: 40px;
}

.contentLeftMenu {
  padding-top: 40px;
}

.contentRightMenu {
  margin-left: 67px;
  flex: 1;
}

/*新菜单*/
.newMenu {
  width: 200px;
  list-style: none;
  margin: 0;
  padding: 0;
}

.newMenuItem {
  display: inline-block;
  width: 100%;
  height: 42px;
  line-height: 42px;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}

.newMenuItem img {
  vertical-align: -3px;
  margin-right: 10px;
  width: 20px;
  height: 18px;
}

.newMenuActive .DropMenu {
  max-height: 600px;
}

.newMenuActive .activeImg {
  display: inline-block;
}

.newMenuActive .normalImg {
  display: none;
}

.newMenuActive .newMenuItem {
  background: #0b8586;
  border-radius: 5px;
  color: #fff;
}

.DropMenu {
  width: 100%;
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 0;
  overflow: hidden;
  transition: all 0.5s;
}

.DropMenuItem {
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 40px;
  cursor: pointer;
}

.DropMenuActive {
  color: #0b8586;
}

.DropMenuTow {
  display: none;
}

.DropMenuActiveTow {
  display: block;
}

.inlinestart20 {
  padding-inline-start: 20px;
}
</style>
